import { AppCategory } from "../enums/AppCategories";

export class AppFunction
{
  category: AppCategory = AppCategory.None;
  get title(): string {
    return this.getTitle();
  }
  constructor(category: AppCategory = AppCategory.None) {
    this.category = category;
  }
  getTitle() {
    switch (this.category) {
      case AppCategory.Dashboard:
        return "Dashboard";
      case AppCategory.WorkOrders:
        return "Work Orders";
      case AppCategory.Invoices:
        return "Invoices";
      case AppCategory.Quotes:
        return "Quotes";
      case AppCategory.Equipment:
        return "Equipment";
      case AppCategory.None:
        return "";
    }

  }
  getIconClass() {
    switch (this.category) {
      case AppCategory.Dashboard:
        return "fa fa-home";
      case AppCategory.WorkOrders:
        return "fas fa-file-alt";
      case AppCategory.Invoices:
        return "fa fa-copy";
      case AppCategory.Quotes:
        return "fas fa-phone-square";
      case AppCategory.Equipment:
        return "fas fa-truck";
      case AppCategory.None:
        return "fa fa-home";
    }
  }
}
